<div class="search-in-page bs-enabled cursor-default">
	<search-box class="d-block" [(model)]="searchTxt"
				(modelChange)="onSearchChange();"
				(clickOutside)="showSearchResults = false;"
				[exclude]="searchSelector"
				(focus)="searchTxt ? (showSearchResults = true) : null"
				placeholder="Search in page">
	</search-box>
	<div class="drop-menu flex-column" [id]="searchSelector"
		 [ngClass]="{'active' : showSearchResults}">
		<ul (clickOutside)="showSearchResults = false;"
			[exclude]="'#globalSearchInput'">
			<li *ngFor="let resultObj of searchResults | orderBy: 'rate'"
				(click)="selectResult(resultObj);">
				<a class="flex-column gap-2">
					<b [highlightText]="searchTxt" [isHighlightOn]="true">
						{{resultObj.title || ''}}
					</b>
					<span class="text-muted" style="font-size: 0.7rem;"
						  [highlightText]="searchTxt" [isHighlightOn]="true"
						  *ngIf="resultObj.subtitle">
						{{resultObj.subtitle}}
					</span>
				</a>
			</li>
		</ul>
		<div class="f-1-0 w-100 flex-column centralize" *ngIf="!searchResults?.length">
			<span>No results found</span>
		</div>
	</div>
</div>
